import {
    Button, Dialog, DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Paper,
} from "@mui/material";
import React from "react";
import {Send} from "react-feather";
import {EmailContentService, GrantAccountStatementService} from "../shared/service";
import { Alert } from '@mui/material';


const EmailPreview = (props) => {

    const [disableSendEmail, setDisableSendEmail] = React.useState(false);
    const [preview, setPreview] = React.useState({toList:[], ccList: []});
    const [message, setMessage] = React.useState('');
    const [errorMessage, setErrorMessage] = React.useState('');

    const sendEmails = () => {
        setDisableSendEmail(true);
        GrantAccountStatementService
            .send(props.data.id)
            .then(response => {
           if(response.data.error) {
               setErrorMessage("There was an error sending the email.");
           }else {
               setMessage("The email messages were sent successfully.")
           }
        }).catch(() => {
            setErrorMessage("There was an error sending the email.");
        });
    }

    React.useEffect(() => {
        if (props.open) {
            setErrorMessage('');
            setMessage('');
            setDisableSendEmail(false);
            EmailContentService.getForGas(props.data.id)
                .then((response) => {
                    setPreview(response.data)
                });
        }
    }, [props.open, props.data.id]);

    return (<>
        <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Send GAS to Distribution List</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to send this GAS report to the distribution list?
                </DialogContentText>
                {
                    message && <Alert severity="success">{message}</Alert>
                }
                {
                    errorMessage && <Alert severity="error">{errorMessage}</Alert>
                }
                {props.data.gasReportFile &&
                    <>
                        <b>GAS file:</b>
                        <a target="_blank" rel="noreferrer"
                           href={props.data.gasReportFile.documentLocation}>{props.data.gasReportFile.documentName}</a>
                    </>
                }
                <Divider/>
                <b>To:</b>
                <ul>
                    {preview.toList.map(p => (
                        <li key={p.id}>{p.name} - {p.email}</li>
                    ))}
                </ul>
                <Divider/>
                <b>Cc:</b>
                <ul>
                    {preview.ccList.map(p => (
                        <li key={p.id}>{p.name} - {p.email}</li>
                    ))}

                </ul>
                <Divider/>
                <b>Subject:</b>
                <span>{preview.subject}</span>
                <Divider/>
                <b>Email Body:</b>
                <Paper>
                    <div dangerouslySetInnerHTML={{__html: preview.emailBody}}></div>
                </Paper>
            </DialogContent>
            <DialogActions>
                <Button color="primary"
                    disabled={disableSendEmail}
                    variant="contained"
                        onClick={() => sendEmails()}> <Send/> Send Email</Button>
                <Button onClick={props.handleClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    </>);
}

export default EmailPreview;
